import React from 'react';
import { DocPageLayout } from '../components/DocPageLayout';
import { InfoBox } from '../components/InfoBox';
const cardBrands = [{
  name: 'Visa',
  src: 'https://cdn.magicpatterns.com/uploads/n1zLbM27UgeLk9Z8ehpnAg/Visa_Logo.png'
}, {
  name: 'Mastercard',
  src: 'https://cdn.magicpatterns.com/uploads/k9ED3mNyq4mpmcVbR7oYqN/MasterCard_Logo.png'
}, {
  name: 'UnionPay',
  src: 'https://cdn.magicpatterns.com/uploads/r5WqGY6n6RhSG46P3jhCLA/UnionPay_Logo.png'
}, {
  name: 'PayPak',
  src: 'https://cdn.magicpatterns.com/uploads/n49hwAt3PDuCKUn5uZ1jWu/PayPak_Logo.png'
}, {
  name: 'RAAST',
  src: 'https://cdn.magicpatterns.com/uploads/kdN9XNZ2i2dAFUJvtY4BQB/RAAST_Logo.png'
}];
export function PaymentMethodsPage() {
  return <DocPageLayout title="Payment Methods" description="Offer your customers their preferred way to pay with a wide range of global and local payment methods." data-id="element-1817">
      <p className="text-gray-700 mb-6" data-id="element-1818">
        The gateway supports a comprehensive range of payment methods to help
        you maximize conversion rates and expand your business globally. You can
        enable multiple payment methods to give your customers the flexibility
        to pay how they prefer.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1819">
        Card Payments
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1820">
        Accept all major international and local card brands with full support
        for debit and credit cards.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8" data-id="element-1821">
        {cardBrands.map(card => <div key={card.name} className="bg-white border border-gray-200 rounded-lg p-4 flex flex-col items-center justify-center h-24 hover:shadow-sm transition-shadow" data-id="element-1822">
            <img src={card.src} alt={card.name} className="max-h-12 max-w-full object-contain mb-2" data-id="element-1823" />
            <span className="text-xs text-gray-500 font-medium" data-id="element-1824">
              {card.name}
            </span>
          </div>)}
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1825">
        Digital Wallets
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1826">
        Enable fast, secure checkout with popular digital wallet solutions.
        Customers can pay with a single tap using their stored payment
        credentials.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-1827">
        <div className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-center h-16 shadow-sm" data-id="element-1828">
          <img src="https://cdn.magicpatterns.com/uploads/kq7zD77GSCSoSq6HoK8rHu/Google_Pay_Logo.png" alt="Google Pay" className="h-8 object-contain" data-id="element-1829" />
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-center h-16 shadow-sm" data-id="element-1830">
          <img src="https://cdn.magicpatterns.com/uploads/oKUqxpqcf7k3EpJaFkiGPK/Huawei_Pay_Logo.png" alt="Huawei Pay" className="h-8 object-contain" data-id="element-1831" />
        </div>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1832">
        Local Payment Methods
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1833">
        Depending on your region, additional local payment methods may be
        available including bank transfers, direct debit, and alternative
        payment methods popular in specific markets.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1834">
        Feature Comparison
      </h2>
      <div className="overflow-x-auto my-6" data-id="element-1835">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1836">
          <thead data-id="element-1837">
            <tr className="bg-gray-50" data-id="element-1838">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1839">
                Payment Method
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1840">
                3D Secure
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1841">
                Tokenization
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1842">
                Recurring
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1843">
                Refunds
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-1844">
            <tr data-id="element-1845">
              <td className="px-4 py-3" data-id="element-1846">Visa / Mastercard</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1847">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1848">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1849">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1850">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1851">
              <td className="px-4 py-3" data-id="element-1852">UnionPay</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1853">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1854">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1855">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1856">✓</td>
            </tr>
            <tr data-id="element-1857">
              <td className="px-4 py-3" data-id="element-1858">PayPak</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1859">✓</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1860">—</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1861">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1862">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1863">
              <td className="px-4 py-3" data-id="element-1864">RAAST</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1865">✓</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1866">—</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1867">—</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1868">✓</td>
            </tr>
            <tr data-id="element-1869">
              <td className="px-4 py-3" data-id="element-1870">Google Pay</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1871">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1872">✓</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1873">—</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1874">✓</td>
            </tr>
          </tbody>
        </table>
      </div>

      <InfoBox type="info" title="Regional Availability" data-id="element-1875">
        Not all payment methods are available in every region. Contact your
        account manager to confirm which payment methods are enabled for your
        merchant profile.
      </InfoBox>
    </DocPageLayout>;
}